import React from "react";
import home from '../assets/home_active.png';
import info from '../assets/info.png';
import { REDEEMPAGE_STRINGS } from '../Strings';
class RequestRedeem extends React.Component {
  render() {
    return (
      <div className="w-100 center pa2-l" style={{ minHeight: '100vh' }}>
        <div className="relative ph5-l ph3">
          <div className="flex pt4 justify-center ph3 ph0-l w-100 items-center">
            <div className="flex justify-center items-center ba b--green br-100 w1-3 h1-3">
              <img className="ph3 pv2 pv3-l w2 h2 mv0" src={home} alt="" ></img></div>
            <hr className="bt b--solid b--green w-30 ma0"></hr>
            <div className="flex justify-center items-center ba b--green br-100 w1-3 h1-3">
              <img className="ph3 pv2 pv3-l  w2 h2 mv0" src={home} alt="" ></img></div>
            <hr className="bt b--solid b--green w-30 ma0"></hr>
            <div className="flex justify-center items-center ba b--green br-100 w1-3 h1-3">
              <img className="ph3 pv2 pv3-l w2 h2 mv0" src={home} alt="" ></img></div></div>

          <div className="flex  justify-around items-center">
            <div className="flex w-25 w-30-l flex-column justify-center items-center">
              <p className="f9 tc  lightest-blue">{REDEEMPAGE_STRINGS.KEY_ADD_BANK}</p></div>
            <div className="flex w-50 w-40-l  flex-column justify-center items-center ">
              <p className="f9 tc  lightest-blue">{REDEEMPAGE_STRINGS.KEY_REDEEM_REQEST}</p></div>
            <div className="flex w-25 w-30-l flex-column justify-center items-center"><p className="f9 tc  lightest-blue">{REDEEMPAGE_STRINGS.KEY_KYC}</p></div></div></div>


        <div className=" flex center pt3">
          <label for="redeem" className="lightest-blue f4-l f6-m f7-ns  ">{REDEEMPAGE_STRINGS.KEY_REDEEM_BALANCE}</label><span className="  ml2 f4-l f6-m f7-ns  tc yellow">1234567</span>
          <img className="ml2 w1 h1" src={info} alt=""></img>
        </div>
        <div className=" w-100 flex center pt3">
          <label className="w-60 f4-l f6-m f7-ns pt2 lightest-blue tl" for="amount" >{REDEEMPAGE_STRINGS.KEY_ENTER_REDEEM_AMOUNT}</label>
          <input id="name" className="bb b--blue w-40 bg-transparent lightest-blue pa2 pb1 tl " type="number" placeholder="Enter Amount"></input>
        </div>

        <div className=" w-100 flex center  pt3">
          <label for="amount" className="lh-copy lightest-blue f4-l f6-m f7-ns">Redeemble Amount : </label><span className="lh-copy f4-l f6-m f7-ns ml2  tc yellow">1234567</span>
        </div>
        <div className="ba mb2 relative w-100 br2 mt3">
          <div className="mv2  flex justify-between items-center ph3">
            <div className="w-70 tl">
              <p className="mt2 f4-l f6-m f7-ns mb0 lightest-blue">Axis Bank</p><div className="flex w-60 justify-between items-center"><p className="mv2 f8 blue">XXXXXXXXXXXXXXXX</p></div></div><div className="w-25 w-15-l w-15-m ba b--silver pv1 tc br2 f4-l f6-m f7-ns bg-yellow">APPLY</div></div></div>
        <div className=" ba mb2 relative w-100 br2">
          <div className="mv2 flex justify-between items-center ph3">
            <div className="w-70 tl">
              <p className="mt2 f4-l f6-m f7-ns  mb0 lightest-blue">Canera Bank</p><div className="flex w-60 justify-between items-center"><p className="mv2 f8 blue">XXXXXXXXXXXXXXXX</p></div></div><div className="w-25 w-15-l w-15-m ba b--silver pv1 tc br2 f4-l f6-m f7-ns  bg-yellow">APPLY</div></div></div>

      </div>
    )
  }

}

export default RequestRedeem;